import { connect } from 'react-redux';
import {
  changePasswordReset,
  changePasswordSet,
  customerReset,
  customerSet,
  loaderSet,
  notifySet,
  referralReset,
  referralSet,
  rooftopSet,
  testimonialReset,
  testimonialSet,
  userSet
} from './actions';
import {
  DEFAULT_CHANGE_PASSWORD,
  DEFAULT_CUSTOMER,
  DEFAULT_REFERRAL,
  DEFAULT_TESTIMONIAL,
  DEFAULT_USER,
  DEFAULT_ROOFTOP
} from './reducers';

const mapDispatchToProps = (dispatch) => ({
  setChangePassword: (data) => {
    dispatch(changePasswordSet(data));
  },
  resetChangePassword: () => {
    dispatch(changePasswordReset());
  },
  setCustomer: (data) => {
    dispatch(customerSet(data));
  },
  resetCustomer: () => {
    dispatch(customerReset());
  },
  setLoader: (data) => {
    dispatch(loaderSet(data));
  },
  setNotify: (data) => {
    dispatch(notifySet(data));
  },
  setReferral: (data) => {
    dispatch(referralSet(data));
  },
  resetReferral: () => {
    dispatch(referralReset());
  },
  setTestimonial: (data) => {
    dispatch(testimonialSet(data));
  },
  resetTestimonial: () => {
    dispatch(testimonialReset());
  },
  setUser: (data) => {
    dispatch(userSet(data));
  },
  setRooftop: (data) => {
    dispatch(rooftopSet(data));
  }
});

const mapStateToProps = (state) => ({
  changePassword: state.changePassword ? state.changePassword : DEFAULT_CHANGE_PASSWORD,
  customer: state.customer ? state.customer : DEFAULT_CUSTOMER,
  loader: state.loader ? state.loader : false,
  notify: state.notify ? state.notify : null,
  referral: state.referral ? state.referral : DEFAULT_REFERRAL,
  testimonial: state.testimonial ? state.testimonial : DEFAULT_TESTIMONIAL,
  user: state.user ? state.user : DEFAULT_USER,
  rooftop: state.rooftop ? state.rooftop : DEFAULT_ROOFTOP
});

export default connect(mapStateToProps, mapDispatchToProps);
